import { CreateSDKConfig } from './api/types';
import RFIsApi from './api/RFIsApi';
import UsersApi from './api/UsersApi';
import WorkflowApi from './api/WorkflowApi';
import VirtualFoldersApi from './api/VirtualFoldersApi';
import { getApiBaseUrl } from './config';
import { getExtendedFetch } from './utils/fetchHelpers';

const createSDK = ({ containerId, env, region, fetchOptions }: CreateSDKConfig) => {
  const baseUrl = getApiBaseUrl(containerId, env, region);

  const fetchWithToken = getExtendedFetch(fetchOptions);
  const apiConfig = {
    baseUrl,
    fetchWithToken,
  };
  return {
    RFIs: RFIsApi(apiConfig),
    Users: UsersApi(apiConfig),
    Workflow: WorkflowApi(apiConfig),
    VirtualFolders: VirtualFoldersApi(apiConfig),
  };
};

export default createSDK;
